import React, { Component } from 'react';


import * as c from '../../../constants';
import RadioListField from '../../common/RadioListField';
import { injectIntl } from 'react-intl';

import messages from '../../../translation_hotkey_template';


class GroupTypeRadioField extends Component {
  render() {
    const { label, name, onChange, intl, translation } = this.props;
    const options = [
      { label: intl.formatMessage( messages.label_classification ), value: c.FORM_GROUP_TYPE_CLASS },
      { label: intl.formatMessage( messages.label_item ), value: c.FORM_GROUP_TYPE_ITEM }
    ];

    return (
      <RadioListField 
        className="inline fields ht-marginless"
        name={name}
        label={label}
        options={options}
        onChange={onChange}
        translation={translation}
      />
    );
  }
}


export default injectIntl(GroupTypeRadioField);
